import React from 'react';
import './App.css';
import ResponsiveDrawer from './components/ResponsiveDrawer';

function App() {
    console.log('Allbridge Core SDK Example Project');
    return (
        <div className="App">
            <ResponsiveDrawer/>
        </div>
    );
}

export default App;
